import { render, staticRenderFns } from "./OptionsComponent.vue?vue&type=template&id=1f5106fc&scoped=true&"
import script from "./OptionsComponent.vue?vue&type=script&lang=js&"
export * from "./OptionsComponent.vue?vue&type=script&lang=js&"
import style0 from "./OptionsComponent.vue?vue&type=style&index=0&id=1f5106fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5106fc",
  null
  
)

export default component.exports